
import HypothesisDetailContainer from 'containers/HypothesisDetailContainer';

export default (props: any) => (
  <HypothesisDetailContainer {...props} edit={true} />
);
